import {
    GET_JOB_ORDERS_REQUEST,
    GET_JOB_ORDERS_SUCCESS,
    GET_JOB_ORDERS_FAILURE,
} from './actions';

const initialState = {
    jobOrders: [],
    loading: false,
    error: null,
};

const jobOrderReducer = (state = initialState, action) => {
    console.log(action,state)
    switch (action.type) {
        case GET_JOB_ORDERS_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case GET_JOB_ORDERS_SUCCESS:
            return {
                ...state,
                jobOrders: action.payload,
                loading: false,
                error: null,
            };
        case GET_JOB_ORDERS_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
}

export default jobOrderReducer;